// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ca0c313f","667":"18bb0d4a","977":"7f8b311f"}[chunkId] + ".chunk.js";
};